import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton, ImageListItem, ImageListItemBar, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { CustomImage, isSkeletonLoading } from 'shared';
import { AddImageTile } from 'pages/shared';
import { useProductImage } from './productImage.styles';
import { Skeleton } from '@material-ui/lab';

export function ProductImage({ title, src, readToken, onClick, onDelete, canBeDeleted, height = 254 }) {
  const { t } = useTranslation('common');
  const classes = useProductImage();
  const isLoading = isSkeletonLoading(src);
  return (
    <ImageListItem
      className={classes.tile}
      onClick={!isLoading ? onClick : undefined}
      component="div"
      style={{ height: height }}
    >
      {isLoading ? (
        <Skeleton height={'100%'} />
      ) : (
        <>
          <div className={classes.imageContainer}>
            {src ? (
              <CustomImage src={`${src}${readToken ? `?${readToken}` : ''}`} alt="Image" className={classes.image} />
            ) : (
              <AddImageTile title={t('upload.dialogTitle')} className={classes.item} />
            )}
          </div>
          <ImageListItemBar
            position="top"
            title={title}
            className={`${classes.imageTitle} ${classes.imageTitleTop}`}
            actionIcon={
              <div className={classes.actionIconContainer}>
                {onDelete && canBeDeleted && (
                  <Tooltip title={t('actions.remove')}>
                    <span>
                      <IconButton
                        onClick={evt => {
                          evt.stopPropagation();
                          onDelete();
                        }}
                        aria-label={t('actions.remove')}
                        disabled={!src}
                        color="primary"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </div>
            }
          />
        </>
      )}
    </ImageListItem>
  );
}

ProductImage.propTypes = {
  title: PropTypes.string,
  src: PropTypes.string,
  readToken: PropTypes.string,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  height: PropTypes.number,
  canBeDeleted: PropTypes.bool
};
